import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zef-logo-spinner',
  templateUrl: './logo-spinner.component.html',
  styleUrls: ['./logo-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoSpinner {}
